function elementExists(selectors) {
  return selectors.some(selector => document.querySelector(selector) !== null);
}

function updatePrice(){

  const exists = elementExists([
    '[data-product-handle="soli-connector"]',
    '[data-product-handle="soli-air-canopy"]',
    '[data-product-handle="ultimate-beach-bundle-soli-air-canopy"]',
    '[data-product-handle="ultimate-sideline-bundle"]',
  ]);

  if(!exists) return;

  setTimeout(function() {
    let total;
    const priceMainVariantSelected = 
      $('#container-form-product .product-price-wrap span.product-price__price .money')
      .text()
      .replace('$', '')
      .replace(',', '')
      .trim();
    const quantityMainVarianSelected = $('#custom-add-to-cart-quantity').text()
    total = Number(priceMainVariantSelected) * parseInt(quantityMainVarianSelected);
    total = total.toFixed(0)
    
    // $('.add-essentials_container .block-options-container input:checked').each(function(index, element) {
    //     const currentPrice = $(this).parent('.block-option-item').attr('data-variant-price')
    //     total = Number(total) + parseInt(currentPrice)
    // });
    
    if (window.location.href !== 'https://solioutdoors.com/collections/soli-accessories/products/soli-sand-water-weights') {
      $('#custom-add-to-cart-price').text(`$${total}`);
    }
  }, 500)
  
}
document.addEventListener("DOMContentLoaded", function (event) {
  const buttonSubstractQty = document.querySelector(
    ".custom-add-to-cart-container .button-quantity .substract"
  );
  const buttonAddQty = document.querySelector(
    ".custom-add-to-cart-container .button-quantity .add"
  );

  buttonSubstractQty.addEventListener("click", function () {
    const totalQtyElement = document.querySelector(
      ".custom-add-to-cart-container .button-quantity .quantity-number"
    );
    const totalQtyNumber = totalQtyElement.innerText;

    if (totalQtyNumber == 1) return;

    if (totalQtyNumber) {
      let numberQty = parseInt(totalQtyNumber);
      numberQty--;
      totalQtyElement.innerText = numberQty;
    }
    
    updatePrice();
  });

  buttonAddQty.addEventListener("click", function () {
    const totalQtyElement = document.querySelector(
      ".custom-add-to-cart-container .button-quantity .quantity-number"
    );
    const totalQtyNumber = totalQtyElement.innerText;

    if (totalQtyNumber) {
      let numberQty = parseInt(totalQtyNumber);
      numberQty++;
      totalQtyElement.innerText = numberQty;
    }

    updatePrice()
  });
});

function getAllInputValues() {
  var formData = {};
  
  // Iterate over each input element within the form
  $("#container-form-product input").each(function() {
    var input = $(this);
    var name = input.attr("name");
    var value = input.val();
    
    // Add the name-value pair to the formData object
    formData[name] = value;
  });
  
  return formData;
}

function createBundleGroupId() {
  return `bundle_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

function buildBundleRecipe(items) {
  const recipeMap = new Map();

  items.forEach((item) => {
    const id = Number(item.id);
    const quantity = Number(item.quantity);

    if (!id || !quantity) {
      return;
    }

    recipeMap.set(id, (recipeMap.get(id) || 0) + quantity);
  });

  return Array.from(recipeMap.entries())
    .map(([id, quantity]) => `${id}:${quantity}`)
    .join(',');
}

function applyBundleProperties(formData, config) {
  if (!config || !config.enabled || !Array.isArray(formData.items) || formData.items.length === 0) {
    return;
  }

  const parentItem = formData.items[0];
  const childItems = formData.items.slice(1);
  const recipe = buildBundleRecipe(childItems);

  parentItem.properties = {
    ...(parentItem.properties || {}),
    _bundle_group: config.groupId,
    _bundle_role: 'parent',
    _bundle_name: config.bundleName,
    _bundle_parent_qty: String(parentItem.quantity || 1),
    _bundle_recipe_abs: recipe,
  };

  childItems.forEach((item) => {
    item.properties = {
      ...(item.properties || {}),
      _bundle_group: config.groupId,
      _bundle_role: 'component',
      _bundle_name: config.bundleName,
    };
  });
}

const checkSoldOutBtn = () => {

  setTimeout(() => {
    const buttonAddToCart = $("#custom-add-to-cart-btn")
  
    if($('.shopify-product-form button.add-cart-btn').attr('title') === 'Sold out'){
      buttonAddToCart.addClass('disabled')
      buttonAddToCart.attr("disabled", "disabled");
      buttonAddToCart.text('Sold Out')
      return;
    }
    
    buttonAddToCart.removeAttr("disabled");
    buttonAddToCart.removeClass('disabled');
    buttonAddToCart.text('Add To Bag');
  }, 200)
}

$(document).on("click","[data-option-name='color'] .pg__option__value", function (e, fromMainSlider) {
  e.preventDefault();
  if ($(this).hasClass("selected")) {
    return;
  }

  const colorProductSelected = $(this).attr('title');
  $('.custom-add-to-cart-container .color-selected-circle').attr('data-variant-selected', colorProductSelected)
  updatePrice();
});

$(document).on("click","[data-option-name='size'] .pg__option__value", function (e, fromMainSlider) {
  e.preventDefault();
  if ($(this).hasClass("selected")) {
    return;
  }
  updatePrice();
});

$(document).on("click",".pg__option__values .pg__option__value", function (e, fromMainSlider) {
  e.preventDefault();
  if ($(this).hasClass("selected")) {
    return;
  }
  updatePrice();
  checkSoldOutBtn();
});

$(document).ready(function () {
  updatePrice();
  
  const colorProductSelected = $("[data-option-name='color'] .pg__option__value.selected").attr('title');
  $('.custom-add-to-cart-container .color-selected-circle').attr('data-variant-selected', colorProductSelected)

  $(".add-essentials_container .block-options-container .option-item-label").on('click', function(){
    updatePrice();
  })

  $("#custom-add-to-cart-btn").on('click', function(){
    $(this).attr('disabled', 'disabled')
    const { id } = getAllInputValues();
    const quantityMainVarianSelected = $('#custom-add-to-cart-quantity').text()
    
    let formData = {
      items: [{ 
        id, 
        quantity: parseInt(quantityMainVarianSelected)
      }]
    };

    $('.add-essentials_container .block-options-container input:checked').each(function(index, element) {
        const [variantId, quantity] = $(this).attr('id').split('-')

        if(!variantId || !quantity) return;

        formData.items.push({ id: variantId, quantity })
    });

    const towelElement = $('.product-add-variants-container .variant__item.active');

    if (towelElement.length) { 
        const idTowelElement = towelElement.attr('data-variant')
        formData.items.push({ id: idTowelElement, quantity: 1 });
    }

    const isUltimateBeachBundle = !!document.querySelector('div[data-product-handle="ultimate-beach-bundle-soli-air-canopy"]');
    const isUltimateSidelineBundle = !!document.querySelector('div[data-product-handle="ultimate-sideline-bundle"]');
    const isConectorBundle = !!document.querySelector('div[data-product-handle="soli-2-canopy-connector-bundle"]');
    const isSoliAirTent = !!document.querySelector('div[data-product-handle="soli-air-tent"]');

    const isUltimatebundleTemplate = isUltimateBeachBundle || isUltimateSidelineBundle;
    const isBundleGuardEnabled = isUltimatebundleTemplate || isConectorBundle || isSoliAirTent;
    const bundleGuardConfig = isBundleGuardEnabled
      ? {
          enabled: true,
          groupId: createBundleGroupId(),
          bundleName:
            (document.querySelector('.product-single')?.getAttribute('data-product-handle') || 'bundle').trim(),
        }
      : { enabled: false };

    const selectedAccessories = document.querySelectorAll(
      '.add-bundle-wrapper .block-option-item:not(.soldout) > input[type="radio"]:checked'
    );

    selectedAccessories.forEach(selected => {
      const option = selected.closest('.block-option-item');
      const accessoryVariantId = Number(option?.dataset.variantId);

      if (!accessoryVariantId) {
        return;
      }

      const totalQuantity = isConectorBundle ? 4 : parseInt(quantityMainVarianSelected);
      formData.items.push({ id: accessoryVariantId, quantity: totalQuantity })
    });
    
    if(isUltimatebundleTemplate){
      const variantsIds = new Map([
        ['Heat Wave Orange / 10 ft', 50754944499991],
        ['Heat Wave Orange / 12 ft', 50754944598295],
        ['Ultra Marine Blue / 10 ft', 50754944303383],
        ['Ultra Marine Blue / 12 ft', 50754944401687],
        ['Sage / 10 ft', 50754944106775],
        ['Sage / 12 ft', 50754944205079],
        ['Cool Grey / 10 ft', 50754944696599],
        ['Cool Grey / 12 ft', 50754944794903],

        ['Sage Normal / 10 ft', 44437254144279],
        ['Sage Normal / 12 ft', 49359666610455],
        ['Heat Wave Orange Normal / 10 ft', 44437246247191],
        ['Heat Wave Orange Normal / 12 ft', 49359666413847],
        ['Ultra Marine Blue Normal / 10 ft', 44437253882135],
        ['Ultra Marine Blue Normal / 12 ft', 49359666315543],
        ['Cool Grey Normal / 10 ft', 44437254013207],
        ['Cool Grey Normal / 12 ft', 49359666512151],
        ['2 Mesh Walls / 10 ft', 44421135434007],
        ['2 Mesh Walls / 12 ft', 49359756067095],
        ['Heat Wave Orange / hat', 50754284519703],
        ['Ultra Marine Blue / hat', 50754284552471],
        ['Sage / hat', 50754284585239],
        ['Cool Grey / hat', 50754284618007],
        ['SOLI Sand Water Weights', 50754261156119],
        ['SOLI Air Canopy Weights', 49522115969303]
      ])
      const color = document.querySelector("[data-option-name='color'] .pg__option__value.selected").getAttribute('data-value');
      const size = document.querySelector("[data-option-name='size'] .pg__option__value.selected").getAttribute('data-value');
      const shadeWallSelector = `${color} / ${size}`.trim();

      const shadeWallVariantSelected = variantsIds.get(shadeWallSelector)
      if(shadeWallVariantSelected) {
        formData.items.push({ id: shadeWallVariantSelected, quantity: 1 })
      }
      
      const shadeWallNormalSelector = `${color} Normal / ${size}`.trim();
      const shadeWallNormalVariantSelected = variantsIds.get(shadeWallNormalSelector)
      if(shadeWallNormalVariantSelected) {
        formData.items.push({ id: shadeWallNormalVariantSelected, quantity: 1 })
      }

      const meshWallsSelector = `2 Mesh Walls / ${size}`;
      const meshWallVariantSelected = variantsIds.get(meshWallsSelector)
      if(meshWallVariantSelected) {
        formData.items.push({ id: meshWallVariantSelected, quantity: 1 })
      }

      const soliHatSelector = `${color} / hat`;
      const soliHatVariantSelected = variantsIds.get(soliHatSelector)
      if(soliHatVariantSelected) {
        formData.items.push({ id: soliHatVariantSelected, quantity: 1 })
      }

      if (isUltimateBeachBundle){
        const weightsSelector = 'SOLI Sand Water Weights';
        const weightsVariantSelected = variantsIds.get(weightsSelector)
        if(weightsVariantSelected) {
          formData.items.push({ id: weightsVariantSelected, quantity: 1 })
        }
      }

      if (isUltimateSidelineBundle){
        const weightsSidelineSelector = 'SOLI Air Canopy Weights';
        const weightsSidelineVariantSelected = variantsIds.get(weightsSidelineSelector)
        if(weightsSidelineVariantSelected) {
          formData.items.push({ id: weightsSidelineVariantSelected, quantity: 1 })
        }
      }
    }

    if(isConectorBundle){
      const variantsIds = new Map([
        ['Heat Wave Orange / 10 ft', 50754944499991],
        ['Heat Wave Orange / 12 ft', 50754944598295],
        ['Ultra Marine Blue / 10 ft', 50754944303383],
        ['Ultra Marine Blue / 12 ft', 50754944401687],
        ['Sage / 10 ft', 50754944106775],
        ['Sage / 12 ft', 50754944205079],
        ['Cool Grey / 10 ft', 50754944696599],
        ['Cool Grey / 12 ft', 50754944794903],
        ['Sage Normal / 10 ft', 44437254144279],
        ['Sage Normal / 12 ft', 49359666610455],
        ['Heat Wave Orange Normal / 10 ft', 44437246247191],
        ['Heat Wave Orange Normal / 12 ft', 49359666413847],
        ['Ultra Marine Blue Normal / 10 ft', 44437253882135],
        ['Ultra Marine Blue Normal / 12 ft', 49359666315543],
        ['Cool Grey Normal / 10 ft', 44437254013207],
        ['Cool Grey Normal / 12 ft', 49359666512151],

        ['2 Mesh Walls / 10 ft', 44421135434007],
        ['2 Mesh Walls / 12 ft', 49359756067095],
        ['Heat Wave Orange / hat', 50754284519703],
        ['Ultra Marine Blue / hat', 50754284552471],
        ['Sage / hat', 50754284585239],
        ['Cool Grey / hat', 50754284618007],
        ['SOLI Sand Water Weights', 50168643879191],
        ['SOLI Air Pump Included', 53407093588247],
        ['SOLI Connector / 10 ft', 53184751436055],
        ['SOLI Connector / 12 ft', 53184751468823],
        

        ['ShadeWall Heat Wave Orange / 10 ft', 44437246247191],
        ['ShadeWall Heat Wave Orange / 12 ft', 49359666413847],
        ['ShadeWall Ultra Marine Blue / 10 ft', 44437253882135],
        ['ShadeWall Ultra Marine Blue / 12 ft', 49359666315543],
        ['ShadeWall Sage / 10 ft', 44437254144279],
        ['ShadeWall Sage / 12 ft', 49359666610455],
        ['ShadeWall Cool Grey / 10 ft', 44437254013207],
        ['ShadeWall Cool Grey / 12 ft', 49359666512151],


      ])
      const color = document.querySelector("[data-option-name='color'] .pg__option__value.selected").getAttribute('data-value');
      const size = document.querySelector("[data-option-name='size'] .pg__option__value.selected").getAttribute('data-value');
      
      /** Soli ShadeWall included */
      const shadeWallIncludedSelector = `${color} / ${size}`.trim();
      const shadeWallIncludedVariantSelected = variantsIds.get(shadeWallIncludedSelector)
      if(shadeWallIncludedVariantSelected) {
        formData.items.push({ id: shadeWallIncludedVariantSelected, quantity: 2 })
      }
      /** Soli ShadeWall  */
      const shadeWallSelector = `ShadeWall ${color} / ${size}`.trim();
      const shadeWallVariantSelected = variantsIds.get(shadeWallSelector)
      if(shadeWallVariantSelected) {
        formData.items.push({ id: shadeWallVariantSelected, quantity: 2 })
      }

      const meshWallsSelector = `2 Mesh Walls / ${size}`;
      const meshWallVariantSelected = variantsIds.get(meshWallsSelector)
      if(meshWallVariantSelected) {
        formData.items.push({ id: meshWallVariantSelected, quantity: 1 })
      }

      const soliHatSelector = `${color} / hat`;
      const soliHatVariantSelected = variantsIds.get(soliHatSelector)
      if(soliHatVariantSelected) {
        formData.items.push({ id: soliHatVariantSelected, quantity: 2 })
      }

      const weightsSelector = 'SOLI Sand Water Weights';
      const weightsVariantSelected = variantsIds.get(weightsSelector)
      if(weightsVariantSelected) {
        formData.items.push({ id: weightsVariantSelected, quantity: 2 })
      }
      
      const airPumpIncluded = 'SOLI Air Pump Included';
      const airPumpVariantSelected = variantsIds.get(airPumpIncluded)
      if(airPumpVariantSelected) {
        formData.items.push({ id: airPumpVariantSelected, quantity: 2 })
      }
      
      const connectorSelector = `SOLI Connector / ${size}`;
      const connectorVariantSelected = variantsIds.get(connectorSelector)
      if(connectorVariantSelected) {
        formData.items.push({ id: connectorVariantSelected, quantity: 1 })
      }

    }

    if (isSoliAirTent) {
      const shadeWallVariants = new Map([
        ['Sage / 10 ft', 50754944106775],
        ['Sage / 12 ft', 50754944205079],
        ['Ultra Marine Blue / 10 ft', 50754944303383],
        ['Ultra Marine Blue / 12 ft', 50754944401687],
        ['Heat Wave Orange / 10 ft', 50754944499991],
        ['Heat Wave Orange / 12 ft', 50754944598295],
        ['Cool Grey / 10 ft', 50754944696599],
        ['Cool Grey / 12 ft', 50754944794903]
      ]);

      const color = document.querySelector("[data-option-name='color'] .pg__option__value.selected").getAttribute('data-value');
      const size = document.querySelector("[data-option-name='size'] .pg__option__value.selected").getAttribute('data-value');
      const shadeWallSelector = `${color} / ${size}`.trim();

      const shadeWallVariantSelected = shadeWallVariants.get(shadeWallSelector);
      if (shadeWallVariantSelected) {
        formData.items.push({ id: shadeWallVariantSelected, quantity: 1 });
      }
    }

    applyBundleProperties(formData, bundleGuardConfig);

    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json()) 
    .then(data => {
      if(data.status == 422){
        $(this).attr('disabled', 'disabled');
        $(this).text('out stock');
        return;
      }
      $('#custom-add-to-cart-btn').removeAttr('disabled')
      BT.updateHeaderCartHtml(true);
      // window.location.href= '/cart'
      // window.location.reload();
    })
    .catch((error) => {
      console.error(error);
      $(this).attr('disabled', 'disabled')
    });
  })

  /** Sticky add to cart */

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
  
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0
    );
  }
  
  const addToCartContainer = document.querySelector('.custom-add-to-cart-container');
  const sectionProductContainer = document.querySelector('.shopify-product-form');

  function checkVisibility() { 
    if (window.innerWidth >= 991) {
      if (isInViewport(sectionProductContainer)) {
        addToCartContainer.classList.remove('sticky');
      } else {
        addToCartContainer.classList.add('sticky');
      }
    }
  }
  
  window.addEventListener('scroll', checkVisibility);
  checkVisibility();

  checkSoldOutBtn();
});
